// ══════════════════════════════════════════════
//  操作日志 — 运行时新增存储（原型）
//  仅存放业务操作实时写入的日志，页面读取时与内置种子数据合并
//  TODO: 联调时移除，改由后端统一记录
// ══════════════════════════════════════════════

const PLATFORM_KEY = 'mock_extra_platform_logs';
const ENTERPRISE_KEY = 'mock_extra_enterprise_logs';

const read = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

const write = (key, val) => {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch (e) {
    // 忽略写入异常
  }
};

export const getExtraPlatformLogs = () => read(PLATFORM_KEY);
export const getExtraEnterpriseLogs = () => read(ENTERPRISE_KEY);

const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user_info') || '{}');
  } catch (e) {
    return {};
  }
};

export const nowStr = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
};

// 操作类型（与《日志审计》操作类型标签一致）
export const OP_TYPE = {
  create: '创建',
  update: '编辑',
  status: '状态变更',
  delete: '删除',
};

const buildEntry = ({ operatorName, operatorAccount, module, opType, target, summary, detail, enterpriseName, enterpriseId }) => ({
  key: `log-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
  time: nowStr(),
  operatorName: operatorName || '当前用户',
  operatorAccount: operatorAccount || '-',
  ip: '127.0.0.1',
  module,
  opType,
  target,
  summary,
  detail: detail || null,
  ...(enterpriseId ? { enterpriseName, enterpriseId } : {}),
});

// 写入平台操作日志
export const addPlatformLog = (payload) => {
  const user = getUser();
  const entry = buildEntry({ operatorName: user.nick_name || user.user_name, operatorAccount: user.user_name, ...payload });
  write(PLATFORM_KEY, [entry, ...read(PLATFORM_KEY)]);
  return entry;
};

// 写入企业操作日志
export const addEnterpriseLog = (payload) => {
  const user = getUser();
  const entry = buildEntry({ operatorName: user.nick_name || user.user_name, operatorAccount: user.user_name, ...payload });
  write(ENTERPRISE_KEY, [entry, ...read(ENTERPRISE_KEY)]);
  return entry;
};

// 生成字段变更明细（仅保留有变化的字段）
// labels: { fieldKey: '字段名' }，按 labels 的 key 集合比对
export const buildDetail = (before, after, labels) => {
  const norm = (v) => (v === undefined || v === null || v === '' ? null : v);
  const b = {};
  const a = {};
  Object.keys(labels).forEach((k) => {
    const bv = norm(before ? before[k] : null);
    const av = norm(after ? after[k] : null);
    if (String(bv) !== String(av)) {
      b[k] = bv;
      a[k] = av;
    }
  });
  if (Object.keys(b).length === 0) return null;
  return { before: b, after: a };
};
